import { FestivalMainBannerButton, FestivalMainBannerWrapper } from "./style";
import { FestivalSkeletonWhiteBox } from "../../../../style/skeleton";

const RabbitFestivalMainBannerSkeleton = () => {
  return (
    <FestivalMainBannerWrapper>
      <FestivalSkeletonWhiteBox height="360px" width="100%" radius="0" />
      <FestivalMainBannerButton>
        <div className="button" />
      </FestivalMainBannerButton>
    </FestivalMainBannerWrapper>
  );
};

export default RabbitFestivalMainBannerSkeleton;
